import { memo } from 'react';
import { match } from 'ts-pattern';

import { IdVerificationVendorEnum, VendorEnum } from '@dotfile/shared/domain';

import { VendorIframeProps } from './types';
import { OnfidoIframe } from './vendor/onfido-iframe';
import { UbbleCheckoutIframe } from './vendor/ubble-checkout-iframe';
import { VeriffIframe } from './vendor/veriff-iframe';

type IdVerificationVendorIframeProps = VendorIframeProps & {
  vendor: VendorEnum;
};

// Must memo on verification url to not refresh modal on case checks polling
export const IdVerificationVendorIframe = memo(
  function IdVerificationVendorIframe({
    vendor,
    ...iframeProps
  }: IdVerificationVendorIframeProps) {
    return match(vendor)
      .with(IdVerificationVendorEnum.veriff, () => (
        <VeriffIframe {...iframeProps} />
      ))
      .with(IdVerificationVendorEnum.onfido, () => (
        <OnfidoIframe {...iframeProps} />
      ))
      .otherwise(() => <UbbleCheckoutIframe {...iframeProps} />);
  },
  ({ verificationUrl }, { verificationUrl: nextVerificationUrl }) =>
    verificationUrl === nextVerificationUrl,
);
